/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputDeleteWebAuthnCredentialRequest
 */
export interface InputDeleteWebAuthnCredentialRequest {
    /**
     * 
     * @type {number}
     * @memberof InputDeleteWebAuthnCredentialRequest
     */
    credentialId: number;
}

/**
 * Check if a given object implements the InputDeleteWebAuthnCredentialRequest interface.
 */
export function instanceOfInputDeleteWebAuthnCredentialRequest(value: object): boolean {
    if (!('credentialId' in value)) return false;
    return true;
}

export function InputDeleteWebAuthnCredentialRequestFromJSON(json: any): InputDeleteWebAuthnCredentialRequest {
    return InputDeleteWebAuthnCredentialRequestFromJSONTyped(json, false);
}

export function InputDeleteWebAuthnCredentialRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputDeleteWebAuthnCredentialRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'credentialId': json['credentialId'],
    };
}

export function InputDeleteWebAuthnCredentialRequestToJSON(value?: InputDeleteWebAuthnCredentialRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'credentialId': value['credentialId'],
    };
}

